import { render, staticRenderFns } from "./GoHome.vue?vue&type=template&id=126a921f&scoped=true&"
import script from "./GoHome.vue?vue&type=script&lang=ts&"
export * from "./GoHome.vue?vue&type=script&lang=ts&"
import style0 from "./GoHome.vue?vue&type=style&index=0&id=126a921f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a921f",
  null
  
)

export default component.exports